import { FC } from "react"

import { HeaderLogo, HeaderMenu, HeaderRoot } from "components/Header"

export const PageHeader: FC = () => {
    return (
        <HeaderRoot>
            <HeaderLogo>alter</HeaderLogo>
            <HeaderMenu />
        </HeaderRoot>
    )
}
